import { UserMinus, UserPlus, Trash } from '@phosphor-icons/react';
import { roleBadgeClass } from './AdminUI';

const StatusPill = ({ suspended }) => (
  <span className={`text-[10px] px-2 py-1 rounded-full font-semibold uppercase border ${
    suspended
      ? 'bg-red-50 text-red-700 border-red-200'
      : 'bg-green-50 text-green-700 border-green-200'
  }`}>
    {suspended ? 'Suspended' : 'Active'}
  </span>
);

const UserActions = ({ user, index, onRequest }) => (
  <div className="inline-flex gap-1">
    {user.suspended ? (
      <button
        onClick={() => onRequest('reactivate', user)}
        className="inline-flex items-center gap-1 bg-green-50 hover:bg-green-100 text-green-700 px-2.5 py-1.5 rounded-lg text-[11px] font-semibold"
        data-testid={`reactivate-user-${index}`}
      >
        <UserPlus size={12} weight="bold" /> Reactivate
      </button>
    ) : (
      <button
        onClick={() => onRequest('suspend', user)}
        className="inline-flex items-center gap-1 bg-orange-50 hover:bg-orange-100 text-orange-700 px-2.5 py-1.5 rounded-lg text-[11px] font-semibold"
        data-testid={`suspend-user-${index}`}
      >
        <UserMinus size={12} weight="bold" /> Suspend
      </button>
    )}
    <button
      onClick={() => onRequest('delete', user)}
      className="inline-flex items-center gap-1 bg-red-50 hover:bg-red-100 text-red-700 px-2.5 py-1.5 rounded-lg text-[11px] font-semibold"
      data-testid={`delete-user-${index}`}
    >
      <Trash size={12} weight="bold" /> Delete
    </button>
  </div>
);

const UserRow = ({ user, index, onRequestAction }) => (
  <tr className="hover:bg-gray-50" data-testid={`user-row-${index}`}>
    <td className="px-4 py-3 font-semibold text-gray-900">{user.name}</td>
    <td className="px-4 py-3 text-gray-600">{user.email}</td>
    <td className="px-4 py-3">
      <span className={`text-[10px] px-2 py-1 rounded-full font-semibold uppercase ${roleBadgeClass(user.role)}`}>{user.role}</span>
    </td>
    <td className="px-4 py-3 text-gray-600 hidden md:table-cell">{user.city || '—'}</td>
    <td className="px-4 py-3 text-gray-600 hidden lg:table-cell">{user.phone || '—'}</td>
    <td className="px-4 py-3"><StatusPill suspended={user.suspended} /></td>
    <td className="px-4 py-3 text-right">
      <UserActions user={user} index={index} onRequest={onRequestAction} />
    </td>
  </tr>
);

const UsersTable = ({ users, onRequestAction }) => (
  <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden">
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 border-b border-gray-200">
          <tr>
            <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs uppercase">Name</th>
            <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs uppercase">Email</th>
            <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs uppercase">Role</th>
            <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs uppercase hidden md:table-cell">City</th>
            <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs uppercase hidden lg:table-cell">Phone</th>
            <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs uppercase">Status</th>
            <th className="text-right px-4 py-3 font-semibold text-gray-700 text-xs uppercase">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {users.length === 0 ? (
            <tr><td colSpan={7} className="text-center py-10 text-gray-500">No users match your filters</td></tr>
          ) : users.map((u, i) => (
            <UserRow key={u.email} user={u} index={i} onRequestAction={onRequestAction} />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default UsersTable;
